module.exports = __webpack_public_path__ + "img/cart4.ade15454.svg";